// import React from "react";
// import { 
//   Grid, 
//   Card, 
//   Typography,
//   useTheme,
//   useMediaQuery 
// } from "@mui/material";
// import Icon from "@mui/material/Icon";
// import SoftBox from "components/SoftBox";
// import { useNavigate } from "react-router-dom";

// import { useAuth } from "AuthContext";
// import { hasPermission } from "permissionUtils";

// /* =====================================================
//    ICON CONFIG WITH PERMISSIONS
// ===================================================== */
// const iconData = [
//   {
//     label: "Branch",
//     icon: "account_tree",
//     color: "linear-gradient(135deg, #FF6B35 0%, #FF9E5A 100%)",
//     route: "/branch",
//     permission: "Settings.Branch",
//     bgColor: "rgba(255, 107, 53, 0.1)"
//   },
//   {
//     label: "Department",
//     icon: "corporate_fare",
//     color: "linear-gradient(135deg, #6A11CB 0%, #2575FC 100%)",
//     route: "/department",
//     permission: "Settings.Department",
//     bgColor: "rgba(106, 17, 203, 0.1)"
//   },
//   {
//     label: "Leave Tracker",
//     icon: "event_note",
//     color: "linear-gradient(135deg, #00B4DB 0%, #0083B0 100%)",
//     route: "/layouts/LeaveSettingSection",
//     permission: "Settings.LeaveTracker",
//     bgColor: "rgba(0, 180, 219, 0.1)"
//   },
//   {
//     label: "Attendance",
//     icon: "how_to_reg",
//     color: "linear-gradient(135deg, #FF416C 0%, #FF4B2B 100%)",
//     route: "/attendancek",
//     permission: "Settings.Attendance",
//     bgColor: "rgba(255, 65, 108, 0.1)"
//   },
//   {
//     label: "Shifts",
//     icon: "schedule",
//     color: "linear-gradient(135deg, #11998E 0%, #38EF7D 100%)",
//     route: "/shifts",
//     permission: "Settings.Shifts",
//     bgColor: "rgba(17, 153, 142, 0.1)"
//   },
//   {
//     label: "Designation",
//     icon: "work_outline",
//     color: "linear-gradient(135deg, #F7971E 0%, #FFD200 100%)",
//     route: "/designation",
//     permission: "Settings.Designation",
//     bgColor: "rgba(247, 151, 30, 0.1)"
//   },
//   {
//     label: "Performance",
//     icon: "trending_up",
//     color: "linear-gradient(135deg, #56CCF2 0%, #2F80ED 100%)",
//     route: "/performance",
//     permission: "Settings.Performance",
//     bgColor: "rgba(86, 204, 242, 0.1)"
//   },
//   {
//     label: "Organization Setup",
//     icon: "settings",
//     color: "linear-gradient(135deg, #834D9B 0%, #D04ED6 100%)",
//     route: "/organization-setup",
//     permission: "Settings.OrganizationSetup",
//     bgColor: "rgba(131, 77, 155, 0.1)"
//   },
//   {
//     label: "HR Letters",
//     icon: "mail_outline",
//     color: "linear-gradient(135deg, #EC008C 0%, #FC6767 100%)",
//     route: "/hr-letters",
//     permission: "Settings.HRLetters",
//     bgColor: "rgba(236, 0, 140, 0.1)"
//   },
//   {
//     label: "Compensation",
//     icon: "paid",
//     color: "linear-gradient(135deg, #FF5E62 0%, #FF9966 100%)",
//     route: "/compensation",
//     permission: "Settings.Compensation",
//     bgColor: "rgba(255, 94, 98, 0.1)"
//   },
// ];

// const Mainpage = () => {
//   const navigate = useNavigate();
//   const { userPermission = [] } = useAuth();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));

//   const handleIconClick = (route) => {
//     if (route) navigate(route);
//   };

//   // Filter icons based on permissions
//   const filteredIcons = iconData.filter((item) =>
//     hasPermission(item.permission, userPermission)
//   );

//   return (
//     <SoftBox 
//       p={{ xs: 2, sm: 3, md: 4 }}
//       sx={{
//         minHeight: "calc(100vh - 64px)",
//         background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
//       }}
//     >
//       {/* Header Section */}
//       <SoftBox 
//         mb={4}
//         textAlign="center"
//         sx={{
//           background: "white",
//           borderRadius: 3,
//           p: 3,
//           boxShadow: "0 8px 32px rgba(0, 0, 0, 0.04)",
//         }}
//       >
//         <Typography 
//           variant="h4" 
//           fontWeight="bold"
//           sx={{
//             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//             mb: 1
//           }}
//         >
//           HR Management System
//         </Typography>
//         <Typography variant="body1" color="text.secondary">
//           Manage your organizations settings and configurations
//         </Typography>
//         <SoftBox 
//           sx={{
//             width: 60,
//             height: 4,
//             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//             borderRadius: 2,
//             mx: "auto",
//             mt: 2
//           }}
//         />
//       </SoftBox>

//       {/* Main Grid */}
//       <Grid container spacing={3} justifyContent="center">
//         {filteredIcons.map((item, index) => (
//           <Grid
//             item
//             key={index}
//             sx={{
//               width: {
//                 xs: "50%",      // 2 per row (mobile)
//                 sm: "33.33%",   // 3 per row (tablet)
//                 md: "25%",      // 4 per row
//                 lg: "20%",      // 5 per row (large)
//               },
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <SoftBox
//               sx={{
//                 width: "100%",
//                 maxWidth: 180,
//                 perspective: 1000,
//               }}
//             >
//               <Card
//                 onClick={() => handleIconClick(item.route)}
//                 sx={{
//                   height: 160,
//                   width: "100%",
//                   background: `linear-gradient(135deg, white 0%, ${item.bgColor} 100%)`,
//                   borderRadius: 3,
//                   boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
//                   cursor: "pointer",
//                   transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
//                   position: "relative",
//                   overflow: "hidden",
//                   border: "1px solid rgba(255, 255, 255, 0.3)",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   p: 2,
//                   "&:hover": {
//                     transform: "translateY(-10px) scale(1.02)",
//                     boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
//                     "& .icon-wrapper": {
//                       transform: "scale(1.1) rotate(5deg)",
//                     },
//                     "& .icon-bg": {
//                       opacity: 0.15,
//                       transform: "scale(1.2)",
//                     }
//                   },
//                   "&:active": {
//                     transform: "translateY(-5px) scale(0.98)",
//                   }
//                 }}
//               >
//                 {/* Background decorative element */}
//                 <SoftBox
//                   className="icon-bg"
//                   sx={{
//                     position: "absolute",
//                     top: -20,
//                     right: -20,
//                     width: 80,
//                     height: 80,
//                     background: item.color,
//                     borderRadius: "50%",
//                     opacity: 0.1,
//                     transition: "all 0.4s ease",
//                   }}
//                 />

//                 {/* Icon Container */}
//                 <SoftBox
//                   className="icon-wrapper"
//                   sx={{
//                     width: 70,
//                     height: 70,
//                     borderRadius: "50%",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     mb: 2,
//                     background: "white",
//                     boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
//                     transition: "all 0.3s ease",
//                     position: "relative",
//                     zIndex: 2,
//                   }}
//                 >
//                   <Icon 
//                     sx={{ 
//                       fontSize: 40,
//                       background: item.color,
//                       WebkitBackgroundClip: "text",
//                       WebkitTextFillColor: "transparent",
//                     }}
//                   >
//                     {item.icon}
//                   </Icon>
//                 </SoftBox>

//                 {/* Label */}
//                 <Typography 
//                   variant="subtitle1" 
//                   fontWeight="600"
//                   sx={{
//                     textAlign: "center",
//                     color: "text.primary",
//                     mt: 1,
//                     lineHeight: 1.2,
//                     zIndex: 2,
//                     position: "relative",
//                   }}
//                 >
//                   {item.label}
//                 </Typography>

//                 {/* Subtle click hint */}
//                 <Typography 
//                   variant="caption" 
//                   sx={{
//                     color: "text.secondary",
//                     mt: 0.5,
//                     opacity: 0.7,
//                     fontSize: "0.7rem",
//                     zIndex: 2,
//                     position: "relative",
//                   }}
//                 >
//                   Click to access
//                 </Typography>
//               </Card>
//             </SoftBox>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Empty State */}
//       {filteredIcons.length === 0 && (
//         <SoftBox
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             py: 10,
//             textAlign: "center",
//           }}
//         >
//           <Icon sx={{ fontSize: 80, color: "text.secondary", mb: 2, opacity: 0.5 }}>
//             admin panel settings
//           </Icon>
//           <Typography variant="h5" color="text.secondary" gutterBottom>
//             No modules available
//           </Typography>
//           <Typography variant="body1" color="text.secondary">
//             You dont have permission to access any settings modules.
//           </Typography>
//         </SoftBox>
//       )}

//       {/* Footer stats */}
//       {filteredIcons.length > 0 && (
//         <SoftBox
//           mt={4}
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           <Typography variant="body2" color="text.secondary">
//             <strong>{filteredIcons.length}</strong> of {iconData.length} modules available
//           </Typography>
//         </SoftBox>
//       )}
//     </SoftBox>
//   );
// };

// export default Mainpage;


import React from "react";
import { 
  Grid, 
  Card, 
  Typography,
  useTheme,
  useMediaQuery 
} from "@mui/material";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import { useNavigate } from "react-router-dom";

import { useAuth } from "AuthContext";
import { hasPermission } from "permissionUtils";

/* =====================================================
   ICON CONFIG WITH PERMISSIONS
===================================================== */
const iconData = [
  {
    label: "Branch",
    icon: "account_tree",
    color: "linear-gradient(135deg, #FF6B35 0%, #FF9E5A 100%)",
    route: "/branch",
    permission: "Settings.Branch",
    bgColor: "rgba(255, 107, 53, 0.1)",
  },
  {
    label: "Department",
    icon: "corporate_fare",
    color: "linear-gradient(135deg, #6A11CB 0%, #2575FC 100%)",
    route: "/department",
    permission: "Settings.Department",
    bgColor: "rgba(106, 17, 203, 0.1)",
  },
  {
    label: "Leave Tracker",
    icon: "event_note",
    color: "linear-gradient(135deg, #00B4DB 0%, #0083B0 100%)",
    route: "/layouts/LeaveSettingSection",
    permission: "Settings.LeaveTracker",
    bgColor: "rgba(0, 180, 219, 0.1)",
  },
  {
    label: "Attendance",
    icon: "how_to_reg",
    color: "linear-gradient(135deg, #FF416C 0%, #FF4B2B 100%)",
    route: "/attendancek",
    permission: "Settings.Attendance",
    bgColor: "rgba(255, 65, 108, 0.1)",
  },
  {
    label: "Shifts",
    icon: "schedule",
    color: "linear-gradient(135deg, #11998E 0%, #38EF7D 100%)",
    route: "/shifts",
    permission: "Settings.Shifts",
    bgColor: "rgba(17, 153, 142, 0.1)",
  },
  {
    label: "Designation",
    icon: "work_outline",
    color: "linear-gradient(135deg, #F7971E 0%, #FFD200 100%)",
    route: "/designation",
    permission: "Settings.Designation",
    bgColor: "rgba(247, 151, 30, 0.1)",
  },
  {
    label: "Performance",
    icon: "trending_up",
    color: "linear-gradient(135deg, #56CCF2 0%, #2F80ED 100%)",
    route: "/performance",
    permission: "Settings.Performance",
    bgColor: "rgba(86, 204, 242, 0.1)",
  },
  {
    label: "Organization Setup",
    icon: "settings",
    color: "linear-gradient(135deg, #834D9B 0%, #D04ED6 100%)",
    route: "/organization-setup",
    permission: "Settings.OrganizationSetup",
    bgColor: "rgba(131, 77, 155, 0.1)",
  },
  {
    label: "Global Redirects",
    icon: "link",
    color: "linear-gradient(135deg, #0EA5E9 0%, #14B8A6 100%)",
    route: "/global-redirects",
    permission: "Settings",
    bgColor: "rgba(20, 184, 166, 0.1)",
  },
  {
    label: "HR Letters",
    icon: "mail_outline",
    color: "linear-gradient(135deg, #EC008C 0%, #FC6767 100%)",
    route: "/hr-letters",
    permission: "Settings.HRLetters",
    bgColor: "rgba(236, 0, 140, 0.1)",
  },
  {
    label: "Compensation",
    icon: "paid",
    color: "linear-gradient(135deg, #FF5E62 0%, #FF9966 100%)",
    route: "/compensation",
    permission: "Settings.Compensation",
    bgColor: "rgba(255, 94, 98, 0.1)",
  },
];

const Mainpage = () => {
  const navigate = useNavigate();
  const { userPermission = [] } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const handleIconClick = (route) => {
    if (route) navigate(route);
  };

  /* ================= PERMISSION FILTER ================= */
  const filteredIcons = iconData.filter((item) =>
    hasPermission(item.permission, userPermission)
  );

  return (
    <SoftBox
      p={1}
      sx={{
        minHeight: "calc(100vh - 64px)",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
      }}
    >
      {/* Header */}
      <SoftBox
        mb={2}
        textAlign="center"
        sx={{
          background: "white",
          borderRadius: 3,
          p: 1,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.04)",
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          HR Management System
        </Typography>

        <Typography variant="body1" color="text.secondary">
          Manage your organizations settings and configurations
        </Typography>

        <SoftBox
          sx={{
            width: 60,
            height: 4,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            borderRadius: 2,
            mx: "auto",
          }}
        />
      </SoftBox>

      {/* Grid */}
      <Grid container spacing={2} justifyContent="center">
        {filteredIcons.map((item, index) => (
          <Grid
            item
            key={index}
            sx={{
              width: {
                xs: "50%",
                sm: "33.33%",
                md: "25%",
                lg: "20%",
              },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <SoftBox sx={{ width: "100%", maxWidth: 180 }}>
              <Card
                onClick={() => handleIconClick(item.route)}
                sx={{
                  height: 140,
                  background: `linear-gradient(135deg, white 0%, ${item.bgColor} 100%)`,
                  borderRadius: 3,
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
                  cursor: "pointer",
                  transition: "all 0.4s ease",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
                  },
                  minWidth  : "210px",
                }}
              >
                <Icon
                  sx={{
                    fontSize: 40,
                    background: item.color,
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  {item.icon}
                </Icon>

                <Typography variant="subtitle1" fontWeight={600} mt={2}>
                  {item.label}
                </Typography>

                <Typography variant="caption" color="text.secondary">
                  Click to access
                </Typography>
              </Card>
            </SoftBox>
          </Grid>
        ))}
      </Grid>
    </SoftBox>
  );
};

export default Mainpage;
